import { dayName, formatDate } from '../utils';
import type { DayData } from '../types';

interface Props {
  days: DayData[];
}

export function DaysBreakdown({ days }: Props) {
  return (
    <div class="days-section">
      <div class="ds-title">BREAKDOWN</div>
      {days.map((d) => {
        const active = d.total > 0;
        let p = 0, f = 0, c = 0;
        d.entries?.forEach((e) => e.items?.forEach((i) => {
          p += i.protein || 0;
          f += i.fat || 0;
          c += i.carbs || 0;
        }));
        const meals = d.entries?.map((e) => `${e.meal} ${e.calories}`).join(' / ') || '';

        return (
          <div key={d.date} class={`d-row ${active ? 'active' : ''}`}>
            <div class="d-day">{dayName(d.date)}</div>
            <div class="d-date">{formatDate(d.date)}</div>
            <div class={`d-cal ${active ? 'has' : 'none'}`}>{active ? d.total : '--'}</div>
            <div class="d-detail">{active ? meals : ''}</div>
            <div class="d-macro">
              {active ? `Б${Math.round(p)} Ж${Math.round(f)} У${Math.round(c)}` : ''}
            </div>
          </div>
        );
      })}
    </div>
  );
}
